import { Link } from "@components/Link/Link";
import React from "react";
import { withArticleFooter } from "./withArticleFooter";

const Container = ({ children }: { children: React.ReactNode }) => (
  <aside className="w-full bg-transparent">{children}</aside>
);
const Wrapper = ({ children }: { children: React.ReactNode }) => (
  <div className="mx-auto flex max-w-2xl flex-row justify-between border-t border-tertiary px-midi pb-mega pt-maxi sm:px-maxi md:pb-tera md:pt-mega xl:px-tera">
    {children}
  </div>
);
const Previous = ({ children }: { children: React.ReactNode }) => (
  <div className="flex w-1/2 flex-col items-start pr-midi text-left text-body leading-caption md:w-full">
    {children}
  </div>
);
const Next = ({ children }: { children: React.ReactNode }) => (
  <div className="flex w-1/2 flex-col items-end pl-midi text-right text-body leading-caption md:w-full">
    {children}
  </div>
);

const ArticleFooter = withArticleFooter(({ previous, next, handleClick }) => {
  return (
    <Container>
      <Wrapper>
        <Previous>
          {previous ? (
            <>
              <span>Previous Article</span>
              <Link
                className="underline"
                to={`/articles/${previous?.slug?.current}`}
                onClick={handleClick(
                  "Article",
                  `/articles/${previous?.slug?.current}`,
                )}
              >
                {previous?.title}
              </Link>
            </>
          ) : null}
        </Previous>
        <Next>
          {next ? (
            <>
              <span>Next Article</span>
              <Link
                className="underline"
                to={`/articles/${next?.slug?.current}`}
                onClick={handleClick(
                  "Article",
                  `/articles/${next?.slug?.current}`,
                )}
              >
                {next?.title}
              </Link>
            </>
          ) : null}
        </Next>
      </Wrapper>
    </Container>
  );
});

export default ArticleFooter;
